export type DiffSegment = { type: 'added' | 'removed' | 'unchanged'; value: string };

export type IconDiff = {
  originalIcon?: string;
  proposedIcon?: string;
  originalPlacement?: string;
  proposedPlacement?: string;
  iconChanged: boolean;
  placementChanged: boolean;
};

type BaseFieldDiff = {
  fieldKey: string;
  hasChanges: boolean;
};

export type PlainTextFieldDiff = BaseFieldDiff & {
  // Labels and short strings (for example button text) stay on the lightweight
  // segment-based path instead of going through the rich-text compare editor.
  kind: 'plainText';
  segments: DiffSegment[];
  iconDiff?: IconDiff;
};

export type RichTextFieldDiff = BaseFieldDiff & {
  // Rich text fields render via the read-only Tiptap compare editor, so they
  // only need the original/proposed HTML pair, not plain-text segments.
  kind: 'richText';
  originalHtml: string;
  proposedHtml: string;
};

export type FieldDiff = PlainTextFieldDiff | RichTextFieldDiff;

export type SectionReviewDiff = {
  fieldDiffs: FieldDiff[];
  designChanged: boolean;
  hasAnyChanges: boolean;
  hasCollectionChanges: boolean;
};

export function extractDiffText(segments: DiffSegment[]): { oldText: string; newText: string } {
  const oldText = segments
    .filter((s) => s.type !== 'added')
    .map((s) => s.value)
    .join('');
  const newText = segments
    .filter((s) => s.type !== 'removed')
    .map((s) => s.value)
    .join('');
  return { oldText, newText };
}

export function isPlainTextFieldDiff(diff: FieldDiff): diff is PlainTextFieldDiff {
  return diff.kind === 'plainText';
}

export function isRichTextFieldDiff(diff: FieldDiff): diff is RichTextFieldDiff {
  return diff.kind === 'richText';
}
